<!--
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-12 11:09:08
 * @Description: 有多个游戏采用了共同的布局使用了此文件，如  pages\casino\spacediceGame\index.vue
-->

<template>
    <div
        class="max-w-[1088px] w-full m-auto relative flex py-3 px-3 sm:py-2 justify-center gmd:pt-9 casino-container"
    >
        <slot name="gameBackground"></slot>
        <div class="flex flex-col max-w-[650px] w-full casino-main">
            <slot></slot>
        </div>
        <CasinoHistory class="w-full" />
    </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, onMounted, onUnmounted } from 'vue';
import {toCloseLoading} from '@/layouts/gameCoat/ts/gameCoat';

const abortController = ref(null);
const rect = ref(null);
const casinoMain = ref(null); // '.casino-container .casino-main'
const currScale = ref(null); // 进入页面时的缩放比例

// const props = defineProps({});


/**
 * 监听视图高度变化，使页面等比例缩放
 */
const handleResize = () => {
    const casinoContainer = document.querySelector('.casino-container') as HTMLElement;
    if (!casinoContainer) return; 
    // 获取视口的高度
    const viewportHeight = window.innerHeight;
    const { bottom, y } = rect.value;
    const scrollTop = window.scrollY || window.pageYOffset;
    if (bottom > viewportHeight && scrollTop < viewportHeight){ 
        let scale = viewportHeight / (bottom + y);
        if (viewportHeight < 240){
            scale = viewportHeight / (bottom * 1.5);
        }
        if (viewportHeight < 180){
            scale = viewportHeight / (bottom * 2);
        }
        casinoContainer.style.transform = `scale(${scale})`;
        casinoContainer.style.transformOrigin = 'top center';
    } else {
        casinoContainer.style.transform = `scale(1)`;
    }
    // 存储一下当前页面的缩放比例
    const val = casinoContainer.style.transform.slice(
        6,
        casinoContainer.style.transform.length - 1,
    );
    currScale.value = Number(val);
}

/**
 * 监听页面滚动
 * 当页面滚动距离>视图高度的1/3时，则将页面放大为1:1，否则执行resize事件
 */
const handleScroll = () => {
    const casinoContainer = document.querySelector('.casino-container') as HTMLElement;
    if (!casinoContainer) return;
    // 获取视口的高度
    const viewportHeight = window.innerHeight;
    // 页面滚动距离
    const scrollTop = window.scrollY || window.pageYOffset;
    const singScale = (1 - currScale.value) / 4;
    // 使页面缩放过渡更平滑，添加多段缩放
    if (scrollTop >= (viewportHeight / 4) && scrollTop < (viewportHeight / 3)){
        casinoContainer.style.transform = `scale(${currScale.value + singScale})`;
    } else if (scrollTop >= (viewportHeight / 3) && scrollTop < (viewportHeight / 2)){
        casinoContainer.style.transform = `scale(${currScale.value + singScale * 2})`;
    } else if (scrollTop >= (viewportHeight / 2) && scrollTop < (viewportHeight)){
        casinoContainer.style.transform = `scale(${currScale.value + singScale * 3})`;
    } else if (scrollTop >= (viewportHeight)){
        casinoContainer.style.transform = `scale(1)`;
    }  else {
        handleResize()
    }
}

onBeforeMount(()=>{
    // 关闭 loading 遮罩 
    // console.log('[casino.vue] 关闭 loading 遮罩 '); 
    toCloseLoading();
});

onMounted(() => {
    setTimeout(() => {
        abortController.value = new AbortController();
        casinoMain.value = document.querySelector('.casino-container .casino-main');
        if (!casinoMain.value) return;
        rect.value = casinoMain.value.getBoundingClientRect();
        if (import.meta.dev && localStorage.getItem('devNoShrink')) {
            return; // 防止开发过程被缩放干扰 
        }
        handleResize();
        window.addEventListener('resize', handleResize, {
            signal: abortController.value.signal,
        });
        window.addEventListener('scroll', handleScroll, {
            signal: abortController.value.signal,
        })
    })
    onUnmounted(() => {
        abortController.value?.abort();
    })
})
</script>

<style lang="scss" scoped>
.casino-container {
    transition: transform 0.3s linear;
}
</style>